module.exports = __webpack_public_path__ + "img/auth-bg.be27474c.svg";